import { TabType } from "component/TabControler/types";
import { ReactComponent as Templates } from "assets/template.svg";
import { ReactComponent as Detail } from "assets/detail.svg";
import { TabControler } from "component/TabControler/TabControler";
import { SlotsProps } from "./types";
import "./slots.scss";
import SlotsDetailContainer from "./slotsDetail/SlotsDetailContainer";
import SlotsTemplatesContainer from "./slotsTemplates/SlotsTemplatesContainer";
import { useCallback } from "react";
import { SlotsTabs } from "reducers/types/slots";
import "./i18n";
import { useTranslation } from "react-i18next";
import ExportButton from "component/exportButton/ExportButton";

const tabs: TabType<SlotsTabs>[] = [
  {
    title: "slots:slots",
    id: "slots",
    icon: Detail,
    testId: "slots-tab-detail",
    name: "slots",
  },
  {
    title: "slots:templates",
    id: "templates",
    icon: Templates,
    testId: "slots-tab-templates",
    name: "templates",
  },
];

export const Slots: React.FC<SlotsProps> = ({
  actualPage,
  filters,
  testId,
  shouldRender,
  changePage,
  exportSlots,
}): JSX.Element => {
  const { t } = useTranslation();
  const renderActualTab = useCallback(() => {
    if (actualPage === "templates")
      return <SlotsTemplatesContainer testId="templates" />;
    if (actualPage === "slots")
      return <SlotsDetailContainer testId={`${testId}-detail`} />;
    return null;
  }, [actualPage, testId]);

  const renderExportButton = useCallback(() => {
    if (actualPage === "slots")
      return (
        <ExportButton onClick={() => exportSlots(filters)} testId={testId} />
      );

    return null;
  }, [actualPage, exportSlots, filters, testId]);

  return (
    <div>
      <TabControler<SlotsTabs>
        tabs={tabs}
        changePage={changePage}
        actualPage={actualPage}
        clickable={false}
      />
      <div className="slots-page-header">
        <h1 className="slots-title" data-testId={`${testId}-title`}>
          {actualPage === "slots" ? t("slots:slots") : t("slots:templates")}
        </h1>
        {renderExportButton()}
      </div>
      {shouldRender && renderActualTab()}
    </div>
  );
};
